import React from "react";

const GlobalContext = React.createContext({});

export class GlobalContextProvider extends React.Component {
  state = {
    title: "",
  };

  componentDidMount() {
    this.loadTitle();
  }

  changeTitle = value => {
    this.setState({ title: value }, this.saveTitle(value));
  };

  loadTitle = () => {
    const title = localStorage.getItem("title");
    this.setState({ title });
  };

  saveTitle = value => localStorage.setItem("title", value);

  render() {
    return (
      <GlobalContext.Provider
        value={{
          title: this.state.title,
          changeTitle: this.changeTitle,
          setActionBack: this.setActionBack,
        }}
      >
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}

// create the consumer as higher order component
export const withGlobalContext = ChildComponent => props => (
  <GlobalContext.Consumer>
    {context => <ChildComponent {...props} global={context} />}
  </GlobalContext.Consumer>
);
